// store/reducers/publicLinkSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const publicLinkSlice = createSlice({
  name: 'publicLink',
  initialState: {
    open: false,
    defaultValues: {},
  },
  reducers: {
    openPublicLinkForm(state, action) {
      state.open = true;
      state.defaultValues = action.payload || {};
    },
    closePublicLinkForm(state) {
      state.open = false;
      state.defaultValues = {};
    },
  },
});

export const { openPublicLinkForm, closePublicLinkForm } = publicLinkSlice.actions;
export default publicLinkSlice.reducer;
